import $ from 'jquery';
import {wait} from '../Libraries/Utils';

let navIsOpened = false;
let navIsAnimating = false;
const $navContainer = $('.nav-container');
const $html = $('html');

function isMobile() {
    return $(window).width() < 992;
}

function isDesktop() {
    return !isMobile();
}


function openMenu() {
    if (navIsAnimating) {
        return;
    }
    navIsAnimating = true;

    (async () => {
        if (isMobile()) {
            $('.mega-menu__sections').removeClass('open');
        }

        $navContainer.addClass('open');
        $html.addClass('nav-opened');
        window.requestAnimationFrame(() => {
            $navContainer.addClass('visible');
            $html.addClass('nav-visible');
        });
        await wait(300);

        navIsOpened = true;
        navIsAnimating = false;
    })();
}

function closeMenu() {
    if (navIsAnimating) {
        return;
    }
    navIsAnimating = true;

    (async () => {
        $navContainer.removeClass('visible');
        $html.removeClass('nav-visible');
        await wait(300);
        $navContainer.removeClass('open');
        $html.removeClass('nav-opened');

        navIsOpened = false;
        navIsAnimating = false;
    })();
}

$('.nav-toggle, .fixed-nav-toggle').on('click', ev => {
    ev.preventDefault();
    if (navIsOpened) {
        closeMenu();
    } else {
        openMenu();
    }
});

$(document).on('click', ev => {
    if (!navIsOpened) {
        return;
    }
    const $item = $(ev.target);
    if (
        $item.closest('.nav').length > 0
        || $item.closest('.nav-toggle').length > 0
        || $item.closest('.fixed-nav-toggle').length > 0
    ) {
        return;
    }
    closeMenu();
});

$('.mobile-menu__link').on('click', ev => {
    ev.preventDefault();
    const $mobileLink = $(ev.currentTarget);
    const $link = $('.nav__link--level-1[href="' + $mobileLink.attr('href') + '"]');
    $link.trigger('click');
});

$('.nav__link--level-1').on('click', ev => {
    ev.preventDefault();
    const $link = $(ev.currentTarget);
    const $mobileLink = $('.mobile-menu__link[href="' + $link.attr('href') + '"]');
    const $megaMenu = $($link.attr('href'));
    if ($megaMenu.length === 0) {
        console.warn('No target menu found for link', $link.attr('href'));
        return;
    }
    if (isDesktop() && $megaMenu.hasClass('open')) {
        // already open, do nothing
        return;
    }

    // close _others_
    $('.mega-menu__sections')
        .filter((i, elem) => !$(elem).is($megaMenu))
        .removeClass('open');

    $link.closest('.nav__list--level-1')
        .find('.nav__link--level-1')
        .addClass('default-link');

    $mobileLink.closest('.mega-menu')
        .find('.mobile-menu__link')
        .addClass('default-link');

    if ($megaMenu.hasClass('open')) {
        $megaMenu.removeClass('open');
        $link.addClass('default-link');
        $mobileLink.addClass('default-link');
    } else {
        $megaMenu.addClass('open');
        $link.removeClass('default-link');
        $mobileLink.removeClass('default-link');
    }
});


const $fixedNavToggle = $('.fixed-nav-toggle');
const $fixedFooter = $('.fixed-footer');
$(window).on('scroll', () => {
    if ($(document).scrollTop() > 200) {
        $fixedNavToggle.addClass('visible');
        $fixedFooter.addClass('visible');
    } else {
        $fixedNavToggle.removeClass('visible');
        $fixedFooter.removeClass('visible');
    }
});
$(window).trigger('scroll');

$('.js-mega-menu-nav-toggle').on('click', ev => {
    if (isDesktop()) return;
    const $toggle = $(ev.currentTarget);
    const $item = $toggle.closest('.mega-menu__page').first();
    if ($item.hasClass('opened')) {
        $item.removeClass('opened');
    } else {
        $('.mega-menu__page.opened').removeClass('opened');
        $item.addClass('opened');
    }

});
